<template>
  <router-view />
</template>

<script>
export default {
  name: 'LandPurchaseContractIndex'
}
</script>
